import { sinpePayment, bankTransferPayment } from 'src/constants/paymentTypes';

export default function parseCreditCard(type: string): string {
  return type === bankTransferPayment ? sinpePayment : type;
}
